// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-title{visibility:visible}.hidePieces{display:none}.tox-collection__item-label>h1{visibility:visible;min-height:0;letter-spacing:normal}.tox-notifications-container{position:fixed!important;top:32px!important}", ""]);
// Exports
module.exports = exports;
